import clsx from 'clsx';
import { ReactNode } from 'react';

import styles from '../Button.module.scss';

import { Icon } from '@/components/core';
import { IconsId } from '@/types/icons';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    children: ReactNode;
    iconName?: IconsId;
    hideArrow?: boolean;
}

export const ButtonServer: React.FC<ButtonProps> = ({ children, iconName, hideArrow = false, className, ...props }) => (
    <button
        className={clsx(styles.button, className, 'button', { [styles.hideArrow]: hideArrow })}
        type="button"
        {...props}
    >
        <span className={styles.childrenWrapper}>
            {iconName && <Icon name={iconName} />}
            {children}
        </span>
        {!hideArrow && (
            <div className={clsx(styles.arrowWrapper)}>
                <Icon name="longArrow" />
            </div>
        )}
    </button>
);
